import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import { H4Text } from '@prisjakt/ui/text/variants';

export const Suggestions = styled.div`
  width: 100%;
  max-width: ${layout.pageContent.maxWidth.rem};
  margin: 0 auto;

  ${media.smallOnly`
    position: absolute;
    top: 56px;
    width: 100%;
    height: 150%; // Reserve 50% space due to virtual keyboard on phones
    background: ${p => p.theme.bg.primary};
  `};
`;

export const Inner = styled.div`
  position: absolute;
  max-width: ${layout.pageContent.maxWidth.rem};
  width: 100%;

  ${media.smallOnly`
    position: relative;
    padding: ${layout.measurements.spacing050} 0;
    overflow: hidden;
  `}
`;

export const Items = styled.ul`
  width: 48.5%;
  margin: 0 auto;
  padding: ${layout.measurements.spacing050} 0 ${layout.measurements.spacing050};
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 4px;
  list-style: none;
  z-index: 1;
  margin-top: -${layout.measurements.spacing050};
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);

  ${media.mediumOnly`
    position: relative;
    left: 32%;  
    width: 50%;
    margin: 0;
  `};

  ${media.smallOnly`
    border: none;
    overflow: auto;
    border-radius: none;
    width: 100%;
    min-height: 100%;
    box-shadow: none;
  `}
`;

export const PopularSearchesTitle = styled(H4Text)`
  margin-left: ${layout.measurements.spacing100};
  margin-top: ${layout.measurements.spacing100};
  flex: 0 1 auto;
`;

export const AdItem = styled.li``;
